import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { currentUser, userProfile, loading, isPending, isBanned, isActive, isAdmin } = useAuth();
  const location = useLocation();

  console.log('🔍 ProtectedRoute Debug:', {
    pathname: location.pathname,
    currentUser: currentUser?.email,
    userProfile: userProfile,
    loading,
    isPending,
    isBanned,
    isActive
  });

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}>
        <div>⏳ Đang tải...</div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Block non-admin from admin routes
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/recipes" replace />;
  }

  // Allow access to these pages without any check
  const allowedPages = ['/waiting-approval', '/subscription', '/subscription-expired', '/first-time-setup'];
  if (allowedPages.includes(location.pathname)) {
    console.log('✅ Allowed page, skipping checks');
    return children;
  }

  // Block banned users
  if (isBanned) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: '#f9fafb'
      }}>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <h1>🚫 Tài khoản bị cấm</h1>
          <p>Tài khoản của bạn đã bị cấm sử dụng.</p>
          <p>Vui lòng liên hệ quản trị viên.</p>
        </div>
      </div>
    );
  }

  // V46 FIX: PENDING users với FREE plan tự động không cần redirect waiting-approval
  // Backend đã tạo FREE plan cho user mới, cho phép vào app ngay
  // if (isPending && location.pathname !== '/waiting-approval') {
  //   console.log('⏳ Pending user, redirecting to waiting-approval');
  //   return <Navigate to="/waiting-approval" replace />;
  // }

  // V46 - Check subscription for ACTIVE users
  if (isActive && userProfile) {
    const { subscription_plan, subscription_end_date } = userProfile;

    console.log('🔍 Subscription check:', {
      plan: subscription_plan,
      endDate: subscription_end_date,
      pathname: location.pathname
    });

    // LIFETIME - luôn cho vào
    if (subscription_plan === 'LIFETIME') {
      console.log('✅ LIFETIME subscription');
      return children;
    }

    // V46: Cho vào app dù hết hạn - việc disable tab xử lý trong BottomNavigation
    return children;
  }     

  // Fallback
  if (isActive) {
    console.log('✅ Active user, allowing access (fallback)');
    return children;
  }

  return children;
};

export default ProtectedRoute;